module.exports = __webpack_public_path__ + "static/media/database-table.3b6ea0af.gif";